import { FC } from "react";

import { TDrawerCloseFunction } from "@ryde/shared";

import { LayoutRightHeaderTitleStyled } from "../../../../right";
import { DrawerCloseIconButton } from "../../drawer";
import { RichLogsExportDropdown } from "./rich-logs.export-dropdown";
import { RichViewLogsHeaderStyled } from "./rich-logs.header.styled";
import { IExportLogsCsvData } from "./rich-logs.models";

interface IRichLogsHeaderUi {
  allLogsCsvData: IExportLogsCsvData[];
  filteredLogsCsvData: IExportLogsCsvData[];
  title: string;
  fileName: string;
  onCloseDrawer: TDrawerCloseFunction;
}

export const RichLogsHeaderUi: FC<IRichLogsHeaderUi> = ({
  title,
  allLogsCsvData,
  filteredLogsCsvData,
  fileName,
  onCloseDrawer,
}) => {
  return (
    <RichViewLogsHeaderStyled>
      <DrawerCloseIconButton onCloseDrawer={onCloseDrawer} />
      <LayoutRightHeaderTitleStyled className="DrawerHeaderTitle">
        {title}
      </LayoutRightHeaderTitleStyled>
      <RichLogsExportDropdown
        allLogsCsvData={allLogsCsvData}
        filteredLogsCsvData={filteredLogsCsvData}
        fileName={fileName}
      />
    </RichViewLogsHeaderStyled>
  );
};
